module.exports = {
	"loose": {
		"title": "Banqueroute&nbsp;!",
		"character": {
			"name": "Fiascao",
			"character": "Fiascao",
			"characterImg": "bankr_hoot.png",
			"bio": "Banquier colombien border line, il a toujours du nez pour blanchir de l'argent. Jamais sur la paille, il arrive à prende la poudre d'escampette (et même de perlimpinpin) avant chaque descente de flics.",
			"img": "http://leobrossault.fr/mystere-de-pekin/questions/bankr_hoot.png"
		},
		"text": "Aïe aïe aïe, vous avez vraiment fait les mauvais choix&nbsp;!<br />Après une période d'adaptation difficile, vous n'êtes pas parvenu à faire votre trou en Chinese Super League.<br />Pire que ça, vous vous êtes ruiné en prenant des chemins qui vous ont mené à la banqueroute.<br />Votre carrière chinoise s’arrête ici, essayez de rebondir dans un championnat de 2nde zone. Ca vous tente une expérience en Azerbaïdjan&nbsp;?"
	},
	"win_1": {
		"title": "Vous quittez la Chine&nbsp;!",
		"character": {
			"name": "Poot",
			"character": "Poot",
			"characterImg": "poot.png",
			"bio": "Fermière dans le Drenthe, elle passe son temps à vendre des tulipes sur le trottoir pour subvenir aux besoins de ses nombeux fils.",
			"img": "http://leobrossault.fr/mystere-de-pekin/questions/poot.png"
		},
		"text": "Vous arrêtez le football et en profitez pour faire un petit retour aux sources. Quoi de mieux que de s’évader&nbsp;?<br />Vous décidez de partir au Pays-Bas pour faire du woofing le temps de vous ressourcer. Vous y rencontrez la femme de votre vie, elle s’appelle Poot et elle est exactement ce que vous attendiez.<br />Vous décidez de rester là-bas, vous l’épousez et vous avez un fils ensemble."
	},
	"win_2": {
		"title": "Vous expérience est une réussite&nbsp;!",
		"character": {
			"name": "Mönik",
			"character": "Mönik",
			"characterImg": "monik.png",
			"bio": "Mère poulpe, elle a votre nom tatoué à l’encre de Chine. Après une saison loin de vous, elle s’installe à vos côtés pour contrôler votre vie privée.",
			"img": "http://leobrossault.fr/mystere-de-pekin/questions/monik.png"
		},
		"text": "Cette 1ère saison en Chine est une réussite. Vous n’étiez pas certain en arrivant mais vous décidez de rempiler une année supplémentaire.<br />Ce n’est pas votre compte en banque qui va s’en plaindre.<br />Mais voilà, votre famille vous manque et vous manquez à votre famille.<br />Vous appelez votre mère, Mönik, pour qu’elle vous rejoigne.<br />La vie sera plus belle. "
	},
	"win_3": {
		"title": "Vous êtes devenu une star&nbsp;!",
		"character": {
			"name": "Monsieur Huk",
			"character": "Monsieur Huk",
			"characterImg": "huk.png",
			"bio": "Footix, auteur de manga à succès, il se reconvertit dans les films tendancieux et se fait connaître pour son premier film “Les Geishas d’à côté”.",
			"img": "http://leobrossault.fr/mystere-de-pekin/questions/huk.png"
		},
		"text": "Dites donc, vous n'êtes pas venu pour rien en Chine. C’est carton plein sur le plan sportif mais aussi sur le plan financier.<br />Quel jackpot&nbsp;!<br />Devenu une véritable star, vous êtes sollicité par la Chine entière pour toutes sortes de choses… Des publicités, des actions caritatives… Mais vous, c’est le cinéma qui vous fait rêver. Du coup, vous acceptez le scénario de Monsieur Huk.<br />La sortie du film est une telle réussite que vous devenez son acteur attitré. Vous faîtes définitivement partie des grands&nbsp;!"
	}
};


//////////////////
// WEBPACK FOOTER
// ./data/end.json
// module id = 16
// module chunks = 0